import axios from "axios";

export interface LinkBigCommerceRequest {
  sessionToken: string;
}

interface LinkBigCommerceResponse {
  success: boolean;
  connectionKey?: string;
  error?: string;
  message?: string;
}

export interface LinkBigCommerceResult {
  status: number;
  body: LinkBigCommerceResponse;
}

/**
 * Dashboard-side wrapper for the BigCommerce embedded-app `/link` endpoint, mirroring
 * {@link ShopifyAdminApi} — not through the generated OpenAPI client, because one endpoint with a
 * one-field request is not worth modelling in the spec yet.
 *
 * Returns the raw status alongside the parsed body so the caller can tell 200 from 409 (this store
 * or this account is already connected elsewhere) without re-reading the body's discriminator.
 * `validateStatus: () => true` keeps axios from throwing on a non-2xx; the caller checks `status`.
 */
export class BigCommerceAdminApi {
  // Explicit fields rather than constructor parameter properties, which emit runtime code and are
  // rejected under `erasableSyntaxOnly`.
  private readonly baseUrl: string;
  private readonly accessToken: string;

  constructor(baseUrl: string, accessToken: string) {
    this.baseUrl = baseUrl;
    this.accessToken = accessToken;
  }

  async postLink(
    request: LinkBigCommerceRequest,
  ): Promise<LinkBigCommerceResult> {
    const response = await axios.post(
      `${this.baseUrl}/integrations/bigcommerce/admin-api/link`,
      request,
      {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        validateStatus: () => true,
      },
    );
    return {
      status: response.status,
      body: response.data as LinkBigCommerceResponse,
    };
  }
}
